import { jsx, jsxs } from 'react/jsx-runtime';
import { Icon } from '../icon.js';

function Home(props) {
  return /* @__PURE__ */ jsx(Icon, { ...props, children: /* @__PURE__ */ jsxs(
    "svg",
    {
      "aria-labelledby": "home-icon",
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      role: "img",
      children: [
        /* @__PURE__ */ jsx("title", { id: "home-icon", children: "A home icon" }),
        /* @__PURE__ */ jsx("path", { d: "M4.5 19V10.1539C4.5 9.86765 4.56402 9.5965 4.69207 9.34041C4.82012 9.08433 4.99712 8.87344 5.22307 8.70774L10.9154 4.41929C11.2313 4.17826 11.5923 4.05774 11.9984 4.05774C12.4046 4.05774 12.7666 4.17826 13.0846 4.41929L18.7769 8.70774C19.0028 8.87344 19.1798 9.08433 19.3079 9.34041C19.4359 9.5965 19.5 9.86765 19.5 10.1539V19C19.5 19.409 19.3522 19.7612 19.0567 20.0567C18.7612 20.3522 18.4089 20.5 18 20.5H14.8077C14.5516 20.5 14.3369 20.4134 14.1637 20.2401C13.9904 20.0669 13.9038 19.8522 13.9038 19.5961V14.7115C13.9038 14.4554 13.8172 14.2408 13.6439 14.0675C13.4707 13.8943 13.2561 13.8077 13 13.8077H11C10.7439 13.8077 10.5292 13.8943 10.356 14.0675C10.1827 14.2408 10.0961 14.4554 10.0961 14.7115V19.5961C10.0961 19.8522 10.0095 20.0669 9.83627 20.2401C9.66304 20.4134 9.44838 20.5 9.1923 20.5H5.99997C5.59101 20.5 5.23877 20.3522 4.94327 20.0567C4.64776 19.7612 4.5 19.409 4.5 19Z" })
      ]
    }
  ) });
}

export { Home as default };
